var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverVendorAssesment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3401 10.7709L18.4095 11.848L13.4213 16.882L10.7706 14.2084L11.8401 13.1313L13.4213 14.7202L17.3401 10.7709ZM8.86089 14.2084L11.1526 16.5001H3.51367V14.9723C3.51367 13.2841 6.24839 11.9167 9.62478 11.9167L11.0685 12.0007L8.86089 14.2084ZM9.62478 4.27783C10.4352 4.27783 11.2124 4.59976 11.7854 5.17278C12.3584 5.74581 12.6803 6.523 12.6803 7.33339C12.6803 8.14377 12.3584 8.92096 11.7854 9.49399C11.2124 10.067 10.4352 10.3889 9.62478 10.3889C8.8144 10.3889 8.03721 10.067 7.46418 9.49399C6.89115 8.92096 6.56923 8.14377 6.56923 7.33339C6.56923 6.523 6.89115 5.74581 7.46418 5.17278C8.03721 4.59976 8.8144 4.27783 9.62478 4.27783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverVendorAssesment);
export default __webpack_public_path__ + "static/media/hoverVendorAssesment.d194ec703646dc23f8b0d67002a04ad4.svg";
export { ForwardRef as ReactComponent };